export enum Font {
  YESMyoungjo = 'YESMyoungjo',
  NanumSquareNeo = 'NanumSquareNeoOTF-bRg',
  RidiBatang = 'RIDIBatang',
  Pretendard = 'Pretendard',
  HSBomBaram = 'HSBomBaram',
  Cafe24ClassicType = 'Cafe24ClassicType',
  HancomMalangMalang = 'HancomMalangMalang',
  TlabShinYB = 'TlabShinYB',
  Danjo = 'Danjo',
  BookkMyungjo = 'BookkMyungjo',
  Warhaven = 'Warhaven',
}

export const FancyShareFontList = [Font.RidiBatang, Font.NanumSquareNeo, Font.YESMyoungjo];

export const ContentCoverFontList = [
  Font.HSBomBaram,
  Font.Cafe24ClassicType,
  Font.HancomMalangMalang,
  Font.TlabShinYB,
  Font.Danjo,
  Font.BookkMyungjo,
  Font.Warhaven,
  Font.YESMyoungjo,
  Font.RidiBatang,
  Font.NanumSquareNeo,
  Font.Pretendard,
];

export const FontText: Record<Font, string> = {
  [Font.HSBomBaram]: '봄바람체',
  [Font.Cafe24ClassicType]: '카페24 클래식타입',
  [Font.HancomMalangMalang]: '한컴 말랑말랑',
  [Font.TlabShinYB]: '신영복체',
  [Font.Danjo]: '단조',
  [Font.BookkMyungjo]: '부크크 명조',
  [Font.Warhaven]: '넥슨 워헤이븐',
  [Font.YESMyoungjo]: '예스 명조',
  [Font.RidiBatang]: '리디바탕',
  [Font.NanumSquareNeo]: '나눔스퀘어네오',
  [Font.Pretendard]: 'Pretendard',
};
